export default [
    "PFPF",
    "PFF",
    "HF"
];

// Locales for which flight packages are enabled (UK and NL websites)
export const flightEnabledLocales = ["en_US", "nl_NL"];

export const isFlightEnabledLocale = (locale: string): boolean =>
    flightEnabledLocales.includes(locale?.replace("-", "_"));
